import {
  type AdminFeedbackType,
  type FeedbackClassification,
  type FeedbackStatus,
} from '../types/feedback';

export const FEEDBACK_TYPE_LABELS: Record<AdminFeedbackType, string> = {
  good_answer: 'Bra svar',
  bad_answer: 'Fel svar',
  missing_knowledge: 'Saknar kunskap',
  wrong_intent: 'Fel intent',
  should_escalate: 'Borde eskaleras',
  ui_bug: 'UI-bugg',
  backend_bug: 'Backend-bugg',
};

export const FEEDBACK_STATUS_LABELS: Record<FeedbackStatus, string> = {
  new: 'Ny',
  triaged: 'Triaged',
  knowledge_created: 'Knowledge skapad',
  eval_added: 'Eval tillagd',
  github_issue_created: 'GitHub issue skapad',
  resolved: 'Löst',
  rejected: 'Avvisad',
};

export const FEEDBACK_STATUS_COLORS: Record<FeedbackStatus, string> = {
  new: 'border-indigo-300 text-indigo-700 bg-indigo-50',
  triaged: 'border-purple-300 text-purple-700 bg-purple-50',
  knowledge_created: 'border-emerald-300 text-emerald-700 bg-emerald-50',
  eval_added: 'border-teal-300 text-teal-700 bg-teal-50',
  github_issue_created: 'border-blue-300 text-blue-700 bg-blue-50',
  resolved: 'border-green-300 text-green-700 bg-green-50',
  rejected: 'border-slate-300 text-slate-700 bg-slate-50',
};

export const FEEDBACK_CLASSIFICATION_COLORS: Record<FeedbackClassification, string> = {
  knowledge_gap: 'border-orange-300 text-orange-700 bg-orange-50',
  wrong_policy: 'border-red-300 text-red-700 bg-red-50',
  bad_answer_quality: 'border-amber-300 text-amber-700 bg-amber-50',
  wrong_intent: 'border-purple-300 text-purple-700 bg-purple-50',
  missing_escalation: 'border-orange-300 text-orange-700 bg-orange-50',
  tool_error: 'border-slate-300 text-slate-700 bg-slate-50',
  ui_bug: 'border-blue-300 text-blue-700 bg-blue-50',
  backend_bug: 'border-slate-300 text-slate-700 bg-slate-50',
  product_data_issue: 'border-yellow-300 text-yellow-700 bg-yellow-50',
  duplicate: 'border-teal-300 text-teal-700 bg-teal-50',
  not_actionable: 'border-gray-300 text-gray-700 bg-gray-50',
};
